"use strict"
var moment = require("moment/min/moment-with-locales.min.js");
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = moment;



//////////////////
// WEBPACK FOOTER
// ./node_modules/moment-with-locales-es6/index.js
// module id = 126
// module chunks = 0